const AuditHome = () => import(/* webpackChunkName: "group-users" */ '../_views/AuditHome')

import { permissoesAuditoria } from '../../../utils/permissoesUsuarios'

export default [
  {
    path: 'audit',
    component: AuditHome,
    meta: { requiresAuth: true, permissions: [...permissoesAuditoria] },
    name: 'Audit',
  },
]
